
function componentToHex(c) {
  const hex = parseInt(c, 10).toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

export const rgbToHex = function (value) {
  if (value.startsWith('#')) {
    return value;
  }
  const m = value.match(/\d+/g);
  return '#' + componentToHex(m[0]) + componentToHex(m[1]) + componentToHex(m[2]);
};
